"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const kheti_1 = require("../axios/kheti");
const updateUserDetails = async (body, sourceId) => {
    try {
        if (sourceId) {
            body.source = [sourceId];
        }
        return await (0, kheti_1.patch)('/user/v1/profile-update', body);
    }
    catch {
        return null;
    }
};
exports.default = updateUserDetails;
